import { initializeApp } from 'firebase/app';
import { getPerformance } from "firebase/performance";
import { getAuth } from "firebase/auth";



// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyBZjXuNco8Z4psFHG2m50AvYDZKXamJhsA",
    authDomain: "al-ghaith-website-data.firebaseapp.com",
    projectId: "al-ghaith-website-data",
    storageBucket: "al-ghaith-website-data.firebasestorage.app",
    messagingSenderId: "427277104227",
    appId: "1:427277104227:web:9d0f4030622d0e35ca7456",
    measurementId: "G-JT1YP10JF6"
  };

  const Firebase = initializeApp(firebaseConfig);
  const perf = getPerformance(Firebase);
  const auth = getAuth(Firebase)
  export {Firebase}






// // Import the necessary Firebase modules
// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getAuth } from "firebase/auth";


// // Your Firebase config here



//   // Initialize Firebase
//   export const app = initializeApp(firebaseConfig);
//   export const db = getFirestore(app);
//   const auth = getAuth(app);